'use client';

import { GoogleReCaptchaProvider } from '@google-recaptcha/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { type PropsWithChildren } from 'react';

// Mounts the Google third-party script providers (reCAPTCHA ~385KB + Google
// Identity ~99KB) only around auth UI. These used to wrap the whole app in
// Provider.tsx, loading ~485KB of script on every pageview for every visitor —
// a top mobile-LCP offender in the 2026-07 audit. Wrap any subtree that
// renders <RecaptchaCheckbox> or <GoogleLogin> with this component.
const AuthScriptProviders = ({ children }: PropsWithChildren) => (
  <GoogleOAuthProvider clientId={process.env.NEXT_PUBLIC_GOOGLE_WEB_CLIENT_ID!}>
    <GoogleReCaptchaProvider
      type="v2-checkbox"
      siteKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
    >
      {children}
    </GoogleReCaptchaProvider>
  </GoogleOAuthProvider>
);

export default AuthScriptProviders;
